import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapperVW'
import HeadTitle from 'src/components/atoms/HeadTitle'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import FadeDownWrap from 'src/components/atoms/FadeDown'
import { Styles } from 'src/components/shared/CssValues'
import PaperCard from 'src/components/molecules/PaperCard'

const whitePapers = [
  {
    thumbnailName: 'commmuneCommunityMarketing',
    subtitle: 'コミュニティ\nマーケティング超入門',
    linkTo: '/whitepapers/commmune_communitymarketing_WP'
  },
  {
    thumbnailName: 'commmuneCommunityTouch',
    subtitle: 'コミュニティタッチ概論',
    linkTo: '/whitepapers/commmune_community_touch'
  },
  {
    thumbnailName: 'commmuneFanmarketing',
    subtitle: 'ロイヤルユーザーを増やすには...\n知っておきたいファンマーケティングとは？',
    linkTo: '/whitepapers/commmune_fanmarketing_WP'
  },
  {
    thumbnailName: 'commmuneCustomerSuccess2',
    subtitle: '今後5年の新潮流!\n「カスタマーサクセス2.0」\n徹底解説',
    linkTo: '/whitepapers/commmune_customersuccess2_WP'
  }
]

export const TopWhitePapers = () => {
  const data = useStaticQuery(graphql`
    query {
      commmuneFanmarketing: file(
        relativePath: { eq: "whitepapers/commmune_fanmarketing.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 475) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      commmuneCommunityMarketing: file(
        relativePath: { eq: "whitepapers/commmune-community-marketing.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 475) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      commmuneCommunityTouch: file(
        relativePath: { eq: "whitepapers/commmune-community-touch.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 475) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      commmuneCustomerSuccess2: file(
        relativePath: { eq: "whitepapers/commmune-customer-success2.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 475) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Container>
      <ContentsWrapper>
        <FadeDownWrap>
          <HeadingBorder heading="E-BOOK" />
        </FadeDownWrap>
        <FadeDownWrap>
          <HeadTitle as="h2" className={"g-h2"}>
            カスタマーサクセス、<br className={"pc-none"} />コミュニティ理解に<br className={"pc-none"} />役立つ資料はこちら
          </HeadTitle>
        </FadeDownWrap>
        <Contents>
          {whitePapers.map((paper, i) => {
            const { childImageSharp } = data[paper.thumbnailName]
            const imageFluid = childImageSharp && childImageSharp.fluid
            return (
              <PaperCard {...paper} imageFluid={imageFluid} key={i} />
            )
          })}
        </Contents>
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.div`
  background-color: ${Styles.color.primary[200]};
`

const Contents = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
